import { render } from "./instructor-course.vue?vue&type=template&id=38cf661a"
import script from "./instructor-course.vue?vue&type=script&lang=js"
export * from "./instructor-course.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__